const tableCellExpiredServices = {
  photo: 'PHOTO'
};

export default tableCellExpiredServices;
